import React, { useMemo } from "react";
import { GitLabData } from "./gitlab.data";
import { useAttributeValueComponents, useRenderers } from "@me8eon/renderers";
import { DisplayData, DisplayDataProps, DisplayDataWidget, translateLabelForData } from "@me8eon/data";
import { SimpleWidget } from "@me8eon/simple_widget";
// @ts-ignore
import icon from "./gitlab.svg";
import { useCommonComponents } from "@me8eon/components";

export const GitLabDisplay: DisplayData<GitLabData> =
    ({ rootId, id, data }: DisplayDataProps<GitLabData>) => {
        const { H1WithIconAndUrl, Markdown, Url } = useRenderers();
        const { Text, DataLayout } = useAttributeValueComponents();
        const { ClipHeight } = useCommonComponents();
        const newRootId = `${rootId}.${id}`;
        const issueSummaryAndUrl = useMemo(() =>
            ({ url: data.url, title: data.fullPath, icon }), [data.url, data.fullPath]);
        return <DataLayout rootId={newRootId} layout={[1, 1, 1, 1]}>
            <H1WithIconAndUrl rootId={newRootId} attribute={translateLabelForData("name")} value={issueSummaryAndUrl} />
            <ClipHeight maxHeight="3rem" force={false}>
                <Markdown rootId={id} attribute={translateLabelForData("description")} value={data.content} />
            </ClipHeight>
            <Text rootId={id} attribute={translateLabelForData("source")} value="gitlab" />
            <Url rootId={id} attribute={translateLabelForData("url")} value={data.url} />
        </DataLayout>;
    };

export const SimpleGitLabOneLineDisplay: DisplayData<GitLabData> =
    ({ data, listItemClicked }: DisplayDataProps<GitLabData>) => {
        const { SearchListItem } = useRenderers();
        const issueSummaryAndUrl = useMemo(() =>
        ({
            title: data.fullPath,
            icon,
            onClick: () => { listItemClicked && listItemClicked(data.fullPath) }
        }), [data.fullPath]);
        return (
            <SearchListItem key={data.fullPath} rootId={data.fullPath} attribute={translateLabelForData('name')} value={issueSummaryAndUrl} />
        )
    }

export const SimpleGitLabWidget: DisplayDataWidget<GitLabData> =
    SimpleWidget(
        ["issue", "summary", "status"],
        ["issue", "summary", "status"],
        ["issue", "status"]);

